module.exports = __webpack_public_path__ + "static/img/应用场景2-员工管理.444225f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-1/应用场景2-员工管理.png
// module id = tZ6o
// module chunks = 0